module.exports = __webpack_public_path__ + "images/emoji/black_circle.688b73a78f6d91e4feff.png";